import { TTabsTheme } from '../../types';

interface IStyles {
  tab: string;
}

export const getTheme = (theme: TTabsTheme) => {
  return require(`./themes/${theme}.css`) as IStyles;
};
